import React from 'react';
import {injectIntl} from "react-intl";
import moment from "moment";
import connect from "react-redux/es/connect/connect";
import {withAuthorization} from "../../../services/Authorization";
import SADatePicker from "../../common/input/SADatePicker";
import Constants from "../../../services/Constants";
import { Button, Table } from "antd";
import AddDayConfigurationMenu from "./AddDayConfigurationMenu";
import Storage from "../../../services/Storage";
import Time from "../../../services/Time";
import {getCamelCaseType} from "../WheelsExchangeUtils";
import CopyConfigsDatePicker from "./CopyConfigsDatePicker";

const Column = Table.Column;

const MAX_CONFIGURATION_RANGES = 2;

class DaysConfiguration extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      configuration: {},
      selectedDay: moment().format(Constants.DATE_FORMAT_API),
      selectedDays: [],
      isDatePickerOpen: false,
      hasError: false
    };
  }

  componentDidMount() {
    const {selectedDay} = this.state;
    const {type} = this.props;
    this.props.dispatchFetchWheelsExchangeSummary({type });
    this.props.dispatchFetchWheelsExchangeConfig({day: selectedDay, type });
  }

  componentWillReceiveProps(nextProps) {
    const configProp = nextProps['fetchWheelsExchangeConfig'];
    if (configProp && configProp.configuration) {
      const {configuration = {}} = this.state;
      const {day} = configProp.configuration;
      configuration[day] = configProp.configuration;
      this.setState({configuration});
    }
  }

  onConfigurationSave = () => {
    const {configuration} = this.state;
    const {type} = this.props;
    this.props.dispatchUpdateWheelsExchangeConfig({configuration: configuration, type});
  };

  onDateChange = (date) => {
    const {type} = this.props;
    const formattedDate = (date) ? moment(date).format(Constants.DATE_FORMAT_API) : null;
    this.setState({selectedDay: formattedDate});
    this.props.dispatchFetchWheelsExchangeConfig({day: formattedDate, type});
    this.props.dispatchFetchWheelsExchangeSummary({type});
  };

  onSelectDate = (date) => {
    const {selectedDays} = this.state;
    const daysSet = [...selectedDays];
    const formattedDate = (date) ? moment(date).format(Constants.DATE_FORMAT_API) : null;
    const foundIndex = daysSet.findIndex(i => i === formattedDate)
    if (foundIndex >= 0) {
      daysSet.splice(foundIndex, 1);
    } else {
      daysSet.push(formattedDate);
    }
    this.setState({selectedDays: daysSet});
  };

  onCopyConfigConfirm = async () => {
    const {
      type,
      fetchWheelsExchangeConfig,
      dispatchUpdateWheelsExchangeConfig,
      dispatchFetchWheelsExchangeConfig,
      dispatchFetchWheelsExchangeSummary
    } = this.props;
    const {selectedDay, selectedDays, configuration} = this.state;

    if (selectedDays.some(day => fetchWheelsExchangeConfig.days.includes(day))) {
      return this.setState({hasError: true});
    }

    if (configuration[selectedDay] && configuration[selectedDay].ranges) {
      const config = {};
      selectedDays.forEach(day => {
        config[day] = {ranges: configuration[selectedDay].ranges};
      });
      dispatchUpdateWheelsExchangeConfig({configuration: config, type});
      dispatchFetchWheelsExchangeConfig({day: selectedDay, type});
    }
    setTimeout(() => dispatchFetchWheelsExchangeSummary({type}), 500);
    this.setState({isDatePickerOpen: false, selectedDays: [], hasError: false});
  }

  onCopyConfigCanceled = () => {
    this.setState({isDatePickerOpen: false, selectedDays: [], hasError: false});
  }

  onRangeSave = (value) => {
    const {selectedDay, configuration = {}} = this.state;
    configuration[selectedDay] = configuration[selectedDay] || {};
    configuration[selectedDay].ranges = configuration[selectedDay].ranges || [];
    configuration[selectedDay].ranges.push(value);
    configuration[selectedDay].ranges.sort((a, b) => moment(a.startTime, Constants.TIME_FORMAT_API).diff(moment(b.startTime, Constants.TIME_FORMAT_API)));
    this.setState({configuration});
  };

  onRangeModify = (newRow, oldRow) => {
    const {selectedDay, configuration = {}} = this.state;
    configuration[selectedDay] = configuration[selectedDay] || {};
    configuration[selectedDay].ranges.push(newRow);
    configuration[selectedDay].ranges.sort((a, b) => moment(a.startTime, Constants.TIME_FORMAT_API).diff(moment(b.startTime, Constants.TIME_FORMAT_API)));
    this.onRangeDelete(oldRow);
  };

  onRangeDelete = (row) => {
    const {selectedDay, configuration = {}} = this.state;
    configuration[selectedDay] = configuration[selectedDay] || {};
    configuration[selectedDay].ranges =  configuration[selectedDay].ranges.filter(e => e !== row);
    this.setState({configuration});
  };

  handleOpenCopyConfigCalendar = () => this.setState({isDatePickerOpen: true});

  render() {
    const {intl: {formatMessage}, updateWheelsExchangeConfig:  {error = {}}, configuredDays} = this.props;
    const {selectedDay, selectedDays, hasError, configuration = {}} = this.state;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';

    const selectedDayRanges = (configuration[selectedDay] && configuration[selectedDay].ranges) || [];
    const errors = error.content || {};

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:`section.exchange-configuration.${this.props.type}.title`})}
          </h2>
          <div className="box-heading__buttons">
            <div className="box-heading__button">
              <CopyConfigsDatePicker
                isOpen={this.state.isDatePickerOpen}
                onChange={this.onSelectDate}
                onConfirm={this.onCopyConfigConfirm}
                onCancel={this.onCopyConfigCanceled}
                multipleDays
                disabledButton={selectedDays.length === 0}
                onDisabledDate={selectedDay}
                showError={hasError}
                dateRender={current => {
                  const style = {};
                  const isConfigured = this.state.selectedDays.includes(current.format(Constants.DATE_FORMAT_API));
                  if (isConfigured) {
                    style.border = '1px solid #1890ff';
                    style.borderRadius = '50%';
                  }
                  return (
                    <div className="ant-calendar-date" style={style}>
                      {current.date()}
                    </div>
                  );
                }}/>
              {canWrite && <button onClick={this.handleOpenCopyConfigCalendar} type="primary" className="btn btn-sm btn-primary">{formatMessage({id:'action.copy'})}</button>}
            </div>
            <div className="box-heading__button">
              {canWrite && <button onClick={this.onConfigurationSave} type="primary" className="btn btn-sm btn-primary">{formatMessage({id:'action.save'})}</button>}
            </div>
          </div>
        </header>
        <div className="box__body">
          <SADatePicker onChange={this.onDateChange} value={selectedDay} dateRender={current => {
            const style = {};
            const isConfigured = configuredDays && configuredDays.includes(current.format(Constants.DATE_FORMAT_API));
            if (isConfigured) {
              style.border = '1px solid #1890ff';
              style.borderRadius = '50%';
            }
            return (
              <div className="ant-calendar-date" style={style}>
                {current.date()}
              </div>
            );
          }}/>

          {errors && errors.configuration &&
            <div className="alert alert--error">
              {formatMessage({id: errors.configuration.message}, {day: moment(errors.configuration.args[0]).format(Constants.DATE_FORMAT_DISPLAY)})}
            </div>
          }

          <div className="mt-4">
            <Table dataSource={selectedDayRanges}  pagination={false}
                   rowKey={(record, lineNumber) => record.startTime + lineNumber}>
              <Column title={formatMessage({id: 'placeholder.startTime'})}
                      dataIndex={'startTime'}
                      render={startTime => Time.timeFromApiToDisplay(startTime)}/>
              <Column title={formatMessage({id: 'placeholder.endTime'})}
                      dataIndex={'endTime'}
                      render={endTime => Time.timeFromApiToDisplay(endTime)}/>
              <Column title={formatMessage({id: 'placeholder.duration'})}
                      dataIndex={'slotDuration'}
                      render={duration => Time.durationToMoment(duration, Constants.TIME_FORMAT_DISPLAY).format(Constants.TIME_FORMAT_DISPLAY)}/>
              <Column title={formatMessage({id: 'placeholder.teams-size'})}
                      dataIndex={'numberOfTeams'}/>
              <Column render={(text, row) =>
                    <AddDayConfigurationMenu data={row} onValidate={(newRow) => this.onRangeModify(newRow, row)} dropdownPosition="right">
                      <a>{formatMessage({id: 'action.edit'})}</a>
                    </AddDayConfigurationMenu>
              }/>
              <Column render={(text, row) =>
                  <a onClick={() => this.onRangeDelete(row)}>{formatMessage({id: 'action.delete'})}</a>
              }/>
            </Table>
          </div>

          {canWrite && selectedDayRanges.length < MAX_CONFIGURATION_RANGES &&
            <div className="list__footer">
              <AddDayConfigurationMenu onValidate={this.onRangeSave}>
                <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                  <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                    <use xlinkHref="#icon-plus"/>
                  </svg>
                  <strong>{formatMessage({id: 'add.more'})}</strong>
                </Button>
              </AddDayConfigurationMenu>
            </div>
          }
        </div>
      </section>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const camelCaseType = getCamelCaseType(ownProps.type);
  const fetchWheelsExchangeConfig = state[`fetch${camelCaseType}ExchangeConfig`];
  const updateWheelsExchangeConfig = state[`update${camelCaseType}ExchangeConfig`];
  const configuredDays = fetchWheelsExchangeConfig && fetchWheelsExchangeConfig.days || [];
  return {
    fetchWheelsExchangeConfig,
    updateWheelsExchangeConfig,
    configuredDays
}};

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchFetchWheelsExchangeConfig: (request) => dispatch({type: `FETCH_${ownProps.type}_EXCHANGE_CONFIG.REQUEST`, request}),
  dispatchFetchWheelsExchangeSummary: (request) => dispatch({type: `FETCH_${ownProps.type}_EXCHANGE_SUMMARY.REQUEST`, request}),
  dispatchUpdateWheelsExchangeConfig: (request) => dispatch({type: `UPDATE_${ownProps.type}_EXCHANGE_CONFIG.REQUEST`, request}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(DaysConfiguration), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/wheelsexchange/configuration/DaysConfiguration.js